/**
 * Shared layout for main app pages: sidebar + scrollable main column.
 */

/** Fixed mobile bottom nav height (matches `h-16` in MainLayout). */
export const BOTTOM_NAV_HEIGHT = '4rem';

/** Extra breathing room below scrollable content on mobile (above bottom nav). */
export const BOTTOM_NAV_SCROLL_PADDING = '0.75rem';

/** Scrollable main column inner width — matches ship-app settings rhythm. */
export const appShellContentClass = 'mx-auto w-full max-w-4xl';

/**
 * Mobile shell column reserve — keeps the scrollable main column above the fixed
 * bottom nav instead of extending underneath it (avoids phantom document scroll).
 */
export const mobileShellBottomReserveClass =
  'max-md:pb-[calc(var(--bottom-nav-height)+env(safe-area-inset-bottom,0px))]';

/** Small breathing room at the end of `<main>` scroll content on mobile. */
export const mobileMainBottomPaddingClass = 'max-md:pb-[var(--bottom-nav-scroll-padding)]';

/**
 * Page `<main>`: vertical rhythm (padding included).
 */
export const appShellMainClass = `${appShellContentClass} space-y-8 px-4 py-8 sm:px-6`;
